import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c702ae4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "rule-input-box"
}
const _hoisted_2 = {
  key: 1,
  class: "rule-input-box"
}
const _hoisted_3 = {
  key: 2,
  class: "rule-input-box"
}
const _hoisted_4 = {
  key: 3,
  class: "rule-input-box"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_6 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_ui_upload_image_list = _resolveComponent("ui-upload-image-list")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "vip-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        ref: "form",
        "label-position": "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "积分任务" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                data: _ctx.list,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "任务导图",
                    fixed: "",
                    width: "150"
                  }, {
                    default: _withCtx(({ row, $index }) => [
                      _createVNode(_component_ui_upload_image_list, {
                        modelValue: row.cover,
                        "onUpdate:modelValue": ($event: any) => ((row.cover) = $event),
                        tips: "更换图片",
                        showClose: false
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "任务名称",
                    width: "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_input, {
                        modelValue: row.name,
                        "onUpdate:modelValue": ($event: any) => ((row.name) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { label: "任务描述" }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_input, {
                        modelValue: row.desc,
                        "onUpdate:modelValue": ($event: any) => ((row.desc) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "触发规则",
                    width: "500"
                  }, {
                    default: _withCtx(({ row }) => [
                      (row.taskInfo.id == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "用户注册并成功登录小程序时触发"))
                        : (row.taskInfo.id == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "用户首次绑定手机成功时触发"))
                          : (row.taskInfo.id == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createTextVNode("用户单笔消费每满时触发"),
                                _createVNode(_component_el_input, {
                                  modelValue: row.value,
                                  "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                                  class: "input-inner-box"
                                }, {
                                  append: _withCtx(() => [
                                    _createTextVNode("元")
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                _createTextVNode("时触发")
                              ]))
                            : (row.taskInfo.id == 4)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createTextVNode("用户每完成 "),
                                  _createVNode(_component_el_input, {
                                    class: "input-inner-box",
                                    modelValue: row.value,
                                    "onUpdate:modelValue": ($event: any) => ((row.value) = $event)
                                  }, {
                                    append: _withCtx(() => [
                                      _createTextVNode("笔")
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                  _createTextVNode("订单时触发")
                                ]))
                              : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "任务周期",
                    width: "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_select, {
                        modelValue: row.cycle,
                        "onUpdate:modelValue": ($event: any) => ((row.cycle) = $event),
                        disabled: row.taskInfo.cycleChange == 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "每日",
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("每日")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "每周",
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("每周")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "每月",
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("每月")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "每年",
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("每年")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "一次性",
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("一次性")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "无期限",
                            value: 6
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("无期限")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "获取积分",
                    width: "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_input, {
                        modelValue: row.score,
                        "onUpdate:modelValue": ($event: any) => ((row.score) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    prop: "operat",
                    fixed: "right",
                    align: "center",
                    width: "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      (row.status == 1)
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 0,
                            type: "primary",
                            onClick: ($event: any) => (row.status = 0)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("停用")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_el_link, {
                            key: 1,
                            type: "success",
                            onClick: ($event: any) => (row.status = 1)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("启用")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          }),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ]),
            _createVNode(_component_el_button, { onClick: _ctx.backEvent }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}